import { createApiReducer } from 'infrastructure/api';

export const initialState = {};

const update = (state, payload) => ({
  ...payload,
  authenticated: true,
});

const handlers = {
  'app/auth/EXTERNAL_PROVIDER_LOGIN': update,
  'app/auth/LOGIN': update,
  'app/auth/REFRESH': update,
  'app/auth/LOGOUT': () => ({}),
};

const apiReducer = createApiReducer(handlers, initialState);

const accountReducer = (state = initialState, action) => {
  if (action.type === 'CLEAR_AUTH') {
    return {};
  }

  return apiReducer(state, action);
};

export default accountReducer;
